import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material'
import { useAppDispatch, useAppSelector } from '@/redux/hooks'
import { getMediaDetailsState, setModalState } from '../slice'

export const ConfirmModal = () => {
  const { open, title } = useAppSelector(getMediaDetailsState).modalState
  const dispatch = useAppDispatch()

  return (
    <Dialog open={open}>
      <DialogTitle>Confirm Recycle</DialogTitle>

      <DialogContent>
        <DialogContentText>{`Do you wish to recycle ${title}?`}</DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button
          variant="outlined"
          color="secondary"
          onClick={() => dispatch(setModalState({ open: false }))}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={() => dispatch(setModalState({ confirm: true }))}
          sx={{ color: '#fff' }}
        >
          Recycle
        </Button>
      </DialogActions>
    </Dialog>
  )
}
